export type StudentGender = "male" | "female";

export interface Script {
  id: string;
  label: string | null;
  createdAt: number;
  uploadEnabled: boolean;
  remoteId: string | null;
  rollNumber: string | null;
  studentName: string | null;
  gender: StudentGender | null;
  subject: string | null;
  section: string | null;
  groundTruthMarksTotal: number | null;
  groundTruthPerQuestionJson: string | null;
}

/** Fields sent to the server on script create/edit — everything except the
 * purely-local bookkeeping (id/createdAt/uploadEnabled/remoteId). */
export interface ScriptMetadataPayload {
  label: string | null;
  rollNumber: string | null;
  studentName: string | null;
  gender: StudentGender | null;
  subject: string | null;
  section: string | null;
  groundTruthMarksTotal: number | null;
  groundTruthPerQuestion: unknown;
}

export function scriptMetadataPayload(script: Script): ScriptMetadataPayload {
  return {
    label: script.label,
    rollNumber: script.rollNumber,
    studentName: script.studentName,
    gender: script.gender,
    subject: script.subject,
    section: script.section,
    groundTruthMarksTotal: script.groundTruthMarksTotal,
    groundTruthPerQuestion: script.groundTruthPerQuestionJson
      ? JSON.parse(script.groundTruthPerQuestionJson)
      : null,
  };
}
